import { render, staticRenderFns } from "./FilePreview.vue?vue&type=template&id=f7b41eba&scoped=true"
import script from "./FilePreview.vue?vue&type=script&lang=js"
export * from "./FilePreview.vue?vue&type=script&lang=js"
import style0 from "./FilePreview.vue?vue&type=style&index=0&id=f7b41eba&prod&lang=less&scoped=true"
import style1 from "./FilePreview.vue?vue&type=style&index=1&id=f7b41eba&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f7b41eba",
  null
  
)

export default component.exports